/* image-slider-swiper.js
   Swiper initializer for image-slider blocks (CDN-based)
   - Expects Swiper UMD to be loaded (swiper-bundle.min.js from CDN)
   - Builds swiper DOM from Shopify block output (handles wrapper divs)
   - Initializes main fade swiper and thumbs swiper when thumbnails enabled
   - Adds destroy/re-init support for Shopify editor hot-reload
*/
(function () {
  "use strict";

  function q(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }
  function qAll(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  function createEl(tag, className) {
    const el = document.createElement(tag);
    if (className) el.className = className;
    return el;
  }

  function initSlider(root) {
    // if already initialized, destroy
    if (root.__swiperInstances) {
      try {
        root.__swiperInstances.main.destroy(true, true);
      } catch (e) {}
      try {
        root.__swiperInstances.thumbs.destroy(true, true);
      } catch (e) {}
      root.__swiperInstances = null;
    }

    const slidesContainer = q(".image-slider__slides", root);
    if (!slidesContainer) return;

    // Gather the inner slide elements (.image-slider__slide) regardless of wrapper divs
    const slideEls = qAll(".image-slider__slide", root);
    if (!slideEls.length) return;

    // Create Swiper structure
    const swiperEl = createEl("div", "swiper image-slider__swiper");
    const wrapper = createEl("div", "swiper-wrapper");

    slideEls.forEach((slideEl) => {
      const slide = createEl("div", "swiper-slide");
      // move the slideEl into the swiper slide (use cloneNode to avoid moving original for editor safety)
      slide.appendChild(slideEl.cloneNode(true));
      wrapper.appendChild(slide);
    });

    swiperEl.appendChild(wrapper);

    // Replace slidesContainer content with swiperEl
    slidesContainer.parentNode.replaceChild(swiperEl, slidesContainer);

    // Thumbs container (if any)
    const thumbsList = q(".image-slider__thumbs-list", root);
    let thumbsSwiper = null;

    // Build thumbs swiper if thumbsList exists
    if (thumbsList) {
      // create a swiper wrap inside thumbsList
      const thumbsContainer = createEl(
        "div",
        "swiper image-slider__thumbs-swiper"
      );
      const thumbsWrapper = createEl("div", "swiper-wrapper");
      // populate from slideEls
      slideEls.forEach((slideEl) => {
        const thumbSlide = createEl("div", "swiper-slide");
        // try to find image inside slideEl
        const img = slideEl.querySelector("img");
        const thumbImg = img ? img.cloneNode(true) : createEl("img");
        thumbSlide.appendChild(thumbImg);
        thumbsWrapper.appendChild(thumbSlide);
      });
      thumbsContainer.appendChild(thumbsWrapper);
      // clear existing thumbsList content and append the thumbsContainer
      thumbsList.innerHTML = "";
      thumbsList.appendChild(thumbsContainer);

      // init thumbs swiper
      thumbsSwiper = new Swiper(thumbsContainer, {
        spaceBetween: 8,
        slidesPerView: "auto",
        watchSlidesProgress: true,
        freeMode: true,
      });
    }

    // init main swiper with fade
    const autoplay = root.dataset.autoplay === "true";
    const interval = parseInt(root.dataset.interval, 10) || 5000;

    console.log("Image Slider Init Debug:", {
      swiperLoaded: typeof Swiper !== "undefined",
      slideCount: slideEls.length,
      thumbsEnabled: !!thumbsList,
      thumbsSwiper: !!thumbsSwiper,
      mainElement: !!swiperEl,
    });

    const main = new Swiper(swiperEl, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      loop: true,
      autoplay: autoplay
        ? { delay: interval, disableOnInteraction: false }
        : false,
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
      // no navigation/pagination as requested
    });

    // store instances for future destroy
    root.__swiperInstances = { main: main, thumbs: thumbsSwiper };

    // expose for debugging
    // root._mainSwiper = main;

    // Log final state
    console.log("Image Slider Initialized", {
      mainSlideCount: main.slides.length,
      thumbSlideCount: thumbsSwiper ? thumbsSwiper.slides.length : 0,
      thumbnailsContainer: thumbsList ? thumbsList.innerHTML : "none",
    });
  }

  function initAll() {
    if (typeof Swiper === "undefined") {
      // Swiper not loaded yet
      return;
    }
    qAll(".image-slider").forEach((root) => initSlider(root));
  }

  // init when DOM ready and when Swiper becomes available
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  // Also attempt to init when Swiper script loads dynamically
  if (typeof Swiper === "undefined") {
    // try polling until Swiper is available (short-lived)
    const poll = setInterval(() => {
      if (typeof Swiper !== "undefined") {
        clearInterval(poll);
        initAll();
      }
    }, 100);
    // stop polling after 5s
    setTimeout(() => clearInterval(poll), 5000);
  }
})();
